import { MusicModel } from '@modules/entertainment/models/music.models.ts';
import { TableSelectionColumnParams } from '@models/table.model.ts';
import { Tooltip } from '@mui/material';
import AppImage from '@components/app-image/app-image.tsx';
import RowActions from '@components/row-actions/row-actions.tsx';
import { getSelectColumn } from '@utils/table-selection.utils.tsx';

export const musicColumns = (
  handleEdit: (row: any) => void,
  handleDelete: (row: any) => void,
  selection: TableSelectionColumnParams<MusicModel>,
  genresLists: any[]
) => [
  getSelectColumn<MusicModel>(selection),
  {
    id: 'title',
    label: 'column_label_title',
    field: 'title',
    render: (value: any) => (
      <Tooltip title={value} followCursor>
        <span>{value || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: true,
    showSearch: true,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'image',
    label: 'column_label_image',
    field: 'image',
    render: (value: any) => (
      <div
        className={`h-13 w-13 rounded-md border border-(--gray-7) overflow-hidden cursor-pointer`}
      >
        <AppImage imgClassName="!h-full" filePath={value ?? undefined} />
      </div>
    ),
    showSort: false,
    showSearch: false,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'authorName',
    label: 'column_label_author_name',
    field: 'authorName',
    render: (value: any) => (
      <Tooltip title={value || 'N/A'} followCursor>
        <span>{value || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'genres',
    label: 'column_label_genres',
    field: 'genres',
    render: (value: any) => {
      const names = Array.isArray(value)
        ? value
            .map((genre: any) => genre?.name?.['en'])
            .filter(Boolean)
            .join(', ')
        : 'N/A';
      return (
        <Tooltip title={names || 'N/A'} followCursor>
          <span>{names || 'N/A'}</span>
        </Tooltip>
      );
    },
    // filterData: genresLists,
    owSort: false,
    showSearch: false,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'createdAt',
    label: 'column_label_date',
    field: 'createdAt',
    render: (value: any) => (
      <Tooltip
        title={value ? new Date(value).toLocaleDateString() : 'N/A'}
        followCursor
      >
        <span>{value ? new Date(value).toLocaleDateString() : 'N/A'}</span>
      </Tooltip>
    ),
    showSort: true,
    showSearch: false,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'Action',
    label: 'column_label_actions',
    field: 'actions',
    render: (value: any, row: any) => (
      <RowActions<any>
        row={row}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />
    ),
    showSort: false,
    showSearch: false,
    showFilter: false
  }
];
